var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgGuestRulesGrToiletSign = function SvgSvgGuestRulesGrToiletSign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 23.5V.5",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.439 8a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5Z",
    fill: "#FFDDA1",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.635 5.286c.033-.177.05-.356.054-.536a3.25 3.25 0 1 0-6.5 0c.003.18.02.36.054.536A4.307 4.307 0 0 0 5.439 3.8a4.3 4.3 0 0 0 3.196 1.486Z",
    fill: "#FFEF5E",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.486 9.955a3.429 3.429 0 0 0-4.037-.012L5.5 13.5l1.986-3.545Z",
    fill: "#FFDDA1",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.817 11.967a3.477 3.477 0 0 0-1.331-2.012L5.5 13.5 3.449 9.943A3.476 3.476 0 0 0 2.1 11.967L.5 17.5H3l1 5h3l1-5h2.5l-1.683-5.533Z",
    fill: "#FF808C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 13.5 3.449 9.943A3.476 3.476 0 0 0 2.1 11.967L.5 17.5H3l1 5h1.5v-9Z",
    fill: "#FFBFC5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.817 11.967a3.477 3.477 0 0 0-1.331-2.012L5.5 13.5 3.449 9.943A3.476 3.476 0 0 0 2.1 11.967L.5 17.5H3l1 5h3l1-5h2.5l-1.683-5.533Z",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8a3.25 3.25 0 1 0 0-6.5A3.25 3.25 0 0 0 19 8Z",
    fill: "#FFDDA1",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.083 4.75c.73 0 1.452-.147 2.123-.434a3.23 3.23 0 0 0-6-1.206 5.4 5.4 0 0 0 3.877 1.64Z",
    fill: "#C77F67",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m20.5 22.5 1-5.5h2v-3a4.5 4.5 0 1 0-9 0v3h2l1 5.5h3Z",
    fill: "#66E1FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19 9.5a4.5 4.5 0 0 0-4.5 4.5v3h2l1 5.5H19v-13Z",
    fill: "#C2F3FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m20.5 22.5 1-5.5h2v-3a4.5 4.5 0 1 0-9 0v3h2l1 5.5h3Z",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSvgGuestRulesGrToiletSign;